import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { IFileProps } from './IFileProps'
import clsx from 'clsx'
import { useFileValidationSchema } from './FileValidationSchema'

interface IFileFieldProps extends HTMLAttributes<HTMLInputElement>, IFileProps {
}

export const SimpleFile: FC<IFileFieldProps> = (props) => {
    const { id, placeholder, className, readOnly, disabled } = props
    const schema = useFileValidationSchema(props)
    const [error, setError] = useState<string>();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        
        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type='file'
            id={id}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
